import type { IconProps } from './types';

export const GridIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M9.25714 3.77143H5.14285C4.38544 3.77143 3.77142 4.38544 3.77142 5.14286V9.25714C3.77142 10.0146 4.38544 10.6286 5.14285 10.6286H9.25714C10.0146 10.6286 10.6286 10.0146 10.6286 9.25714V5.14286C10.6286 4.38544 10.0146 3.77143 9.25714 3.77143Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8572 3.77143H14.7429C13.9855 3.77143 13.3715 4.38544 13.3715 5.14286V9.25714C13.3715 10.0146 13.9855 10.6286 14.7429 10.6286H18.8572C19.6146 10.6286 20.2286 10.0146 20.2286 9.25714V5.14286C20.2286 4.38544 19.6146 3.77143 18.8572 3.77143Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.25714 13.3714H5.14285C4.38544 13.3714 3.77142 13.9854 3.77142 14.7429V18.8571C3.77142 19.6146 4.38544 20.2286 5.14285 20.2286H9.25714C10.0146 20.2286 10.6286 19.6146 10.6286 18.8571V14.7429C10.6286 13.9854 10.0146 13.3714 9.25714 13.3714Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8572 13.3714H14.7429C13.9855 13.3714 13.3715 13.9854 13.3715 14.7429V18.8571C13.3715 19.6146 13.9855 20.2286 14.7429 20.2286H18.8572C19.6146 20.2286 20.2286 19.6146 20.2286 18.8571V14.7429C20.2286 13.9854 19.6146 13.3714 18.8572 13.3714Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
